export interface AlternateMobileNumber {
    questionKey: string;
    answerKey: string;
    UserInputAnswer?: string;
    isResendOTP?: boolean;
    resendType?: "mobile" | "email";
}

export enum CibilStage {
    SKIP_PAN_REQUIRED = "SKIP_PAN_REQUIRED",
    REQUEST_REGISTRATION = "REQUEST_REGISTRATION",
    REQUEST_ALTER_NUMBER = "REQUEST_ALTER_NUMBER",
    SUBMIT_OTP = "SUBMIT_OTP",
    SUBMIT_OTP_EMAIL = "SUBMIT_OTP_EMAIL",
    RESUBMIT_OTP_EMAIL = "RESUBMIT_OTP_EMAIL",
    RESUBMIT_OTP = "RESUBMIT_OTP",
    REQUEST_KBA = "REQUEST_KBA", // Not in use
    NO_DATA_FOUND = "NO_DATA_FOUND",
    GET_CIBIL_DATA = "GET_CIBIL_DATA",
    NO_HISTORY = "NO_HISTORY",
    FETCH_CIBIL_DATA = "FETCH_CIBIL_DATA",
    RESEND_OTP = "RESEND_OTP",
    RESEND_OTP_EMAIL = "RESEND_OTP_EMAIL",
}

export interface IStageApiResponse {
    success?: boolean;
    message?: string;
    stage?: string;
    data?: any;
    callGetStatus?: boolean;
    [key: string]: any;
}

/** 🔹 Generic API Response Wrapper */
export interface ID2CResponse<T = any> {
    success: boolean;
    message: string;
    data: T;
}

/** 🔹 Registration Stage Response */
export interface IRequestRegistrationData {
    stage: string;
    userData: Record<string, any>;
}

/** 🔹 CIBIL Data Stage Response */
export interface ICibilDataWrapper {
    stage: string;
    allowReFetch: boolean;
    cibilData: any;
}

export const TERMS_AND_CONDITIONS_CIBIL_URL =
    "https://storage.googleapis.com/klinq-prod-public/cibil/cibil_1781156998265.pdf#toolbar=0&navpanes=0";
